let _isDev: boolean | undefined

function isDev(): boolean {
	if (_isDev === undefined) {
		try {
			_isDev = useNuxtApp().$config.public.environment !== 'production'
		} catch {
			return false
		}
	}
	return _isDev
}

export const logger = {
	log: (...args: unknown[]) => isDev() && console.log(...args),
	warn: (...args: unknown[]) => isDev() && console.warn(...args),
	error: (...args: unknown[]) => isDev() && console.error(...args),
	info: (...args: unknown[]) => isDev() && console.info(...args),
	debug: (...args: unknown[]) => isDev() && console.debug(...args),
}
